var C = Object.defineProperty;
var c = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var f = (e, r, s) => r in e ? C(e, r, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[r] = s, m = (e, r) => {
  for (var s in r || (r = {}))
    d.call(r, s) && f(e, s, r[s]);
  if (c)
    for (var s of c(r))
      h.call(r, s) && f(e, s, r[s]);
  return e;
};
var g = (e, r) => {
  var s = {};
  for (var o in e)
    d.call(e, o) && r.indexOf(o) < 0 && (s[o] = e[o]);
  if (e != null && c)
    for (var o of c(e))
      r.indexOf(o) < 0 && h.call(e, o) && (s[o] = e[o]);
  return s;
};
import { jsx as y } from "react/jsx-runtime";
import { escapeRegExp as R } from "./HighlightHelpers.js";
import { p as S, f as $, e as w, g as N, B as T, h as B, u as E } from "../../factory--gUH4vxz.js";
import "react";
function k({ color: e, theme: r, defaultShade: s }) {
  const o = S({ color: e, theme: r });
  return o.isThemeColor ? o.shade === void 0 ? `var(--mantine-color-${o.color}-${s})` : `var(${o.variable})` : e;
}
var v = { root: "m_bcb3f3c2" };
const P = {
  color: "yellow"
}, j = B((e, { color: r }) => ({
  root: {
    "--mark-bg-dark": k({ color: r, theme: e, defaultShade: 5 }),
    "--mark-bg-light": k({ color: r, theme: e, defaultShade: 2 })
  }
})), u = $((e, r) => {
  const s = w("Mark", P, e), p = s, { classNames: o, className: a, style: l, styles: i, unstyled: t, vars: n, color: H, variant: M } = p, b = g(p, ["classNames", "className", "style", "styles", "unstyled", "vars", "color", "variant"]), x = N({
    name: "Mark",
    props: s,
    className: a,
    style: l,
    classes: v,
    classNames: o,
    styles: i,
    unstyled: t,
    vars: n,
    varsResolver: j
  });
  return /* @__PURE__ */ y(T, m(m({ component: "mark", ref: r, variant: M }, x("root")), b));
});
u.classes = v;
u.displayName = "@mantine/core/Mark";
const A = ({ highlight: e = "", highlightColor: r, text: s = "", textColor: o }) => {
  const a = E();
  if (!e.trim())
    return s;
  const l = new RegExp(`(${R(e)})`, "gi"), i = (t, n) => l.test(t) ? /* @__PURE__ */ y(
    u,
    {
      color: r || a.colors[a.primaryColor][7],
      style: { color: o || a.white },
      "data-highlighted": !0,
      children: t
    },
    n
  ) : t;
  return s.split(l).filter((t) => t).map((t, n) => i(t, n));
};
export {
  A as Highlight
};
